import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class SplitDocService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  create(docId: string, taskType: 'split' | 'remove', splitString : string): Observable<any> {
    return this.http.post<any>(`${this.appConfigService.getConfig().webApi}/api2/docs/${docId}/SplitDocs`, { 
      taskType,
      splitString,
    })
      .pipe(catchError(this.errorHandler.handleError<any>(`post split jobs`)));
  }
}
